module.exports = __webpack_public_path__ + "static/media/logo.6416ccde.png";